export class UnconveyPropertyResultDto {
    numberOfQuarantinedPayments: number;
}
